namespace advisorop.components.advisor {
    
    export class AdvisorAccountsController {
        $router;
        showClosedAccountsListOption: number;
        filterableAccountsListOption: number;
        accountStatus: number;

        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService) {

        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.accountStatus = next.params.accountStatus ?? 0;
            this.showClosedAccountsListOption = next.params.showClosedAccountsListOption ?? 0;
            this.filterableAccountsListOption = next.params.filterableAccountsListOption ?? 0;
        }

    }



    class AdvisorAccounts implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "advisorService", AdvisorAccountsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-accounts.html';            
        }
    }
    angular.module(Constants.APP).component("advisorAccounts", new AdvisorAccounts());
    
}